module.exports = __webpack_public_path__ + "static/media/bwgr1_.645c23ce.svg";